import * as angular from "angular";
import {TableColumnSizeType} from "../../commons/types/table-column-size.type";

const routeStatuses = [
  'Assigned',
  'Unassigned',
  'Started',
  'Completed',
  'Deleted'
];

const routeGroupKeys = {
  Active: 'Active',
  Finished: 'History'
};

const days = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];

const allRoutesActions = {
  assign: true,
  reOptimize: true,
  editRoute: true,
  resetRoute: true,
  removeRoute: true,
  removeTask: true,
  printRoute: true,
  printLoadingSheet: true,
  printBillOfLading: true,
  downloadBillOfLading: true,
  updateResource: true,
  updateBranches: true,
  associateAgent: true,
  printIkea: true,
  disableAll: true,
  block: true,
  manageAssistants: true,
  updateLogisticVehicle: true,
  mergeRoutes: true,
  sendToPlanning: true
}

const routeActionsByStatus = {
  Unassigned: {
    disableAll: false,
    assign: true,
    reOptimize: true,
    editRoute: true,
    resetRoute: true,
    removeRoute: true,
    removeTask: true,
    printRoute: true,
    printLoadingSheet: true,
    printBillOfLading: true,
    downloadBillOfLading: true,
    updateResource: true,
    updateBranches: true,
    block: true,
    printIkea: true
  },
  Assigned: {
    disableAll: false,
    assign: true,
    reOptimize: false,
    editRoute: true,
    resetRoute: true,
    removeRoute: false,
    removeTask: false,
    printRoute: true,
    printLoadingSheet: true,
    printBillOfLading: true,
    downloadBillOfLading: true,
    updateResource: true,
    updateBranches: true,
    block: true,
    printIkea: true
  },
  Started: {
    disableAll: false,
    assign: true,
    reOptimize: false,
    editRoute: true,
    resetRoute: true,
    removeRoute: false,
    removeTask: false,
    printRoute: true,
    printLoadingSheet: true,
    printBillOfLading: true,
    downloadBillOfLading: true,
    updateResource: true,
    updateBranches: true,
    block: true,
    printIkea: true
  },
  CourierHeading: {
    disableAll: false,
    assign: true,
    reOptimize: false,
    editRoute: true,
    resetRoute: true,
    removeRoute: false,
    removeTask: false,
    printRoute: true,
    printLoadingSheet: true,
    printBillOfLading: true,
    downloadBillOfLading: true,
    updateResource: true,
    updateBranches: true,
    block: true,
    printIkea: true
  },
  Completed: {
    disableAll: true,
    assign: false,
    reOptimize: false,
    editRoute: false,
    resetRoute: false,
    removeRoute: false,
    removeTask: false,
    printRoute: true,
    printLoadingSheet: true,
    printBillOfLading: true,
    downloadBillOfLading: true,
    updateResource: false,
    updateBranches: false,
    block: false,
    printIkea: true
  },
  Canceled: {
    disableAll: true,
    assign: false,
    reOptimize: false,
    editRoute: false,
    resetRoute: false,
    removeRoute: false,
    removeTask: false,
    printRoute: true,
    printLoadingSheet: true,
    printBillOfLading: true,
    downloadBillOfLading: true,
    updateResource: false,
    updateBranches: false,
    block: false,
    printIkea: true
  },
  Deleted: {
    disableAll: true,
    assign: false,
    reOptimize: false,
    editRoute: false,
    resetRoute: false,
    removeRoute: false,
    removeTask: false,
    printRoute: false,
    printLoadingSheet: false,
    printBillOfLading: false,
    downloadBillOfLading: false,
    updateResource: false,
    updateBranches: false,
    block: false,
    printIkea: false
  }
};

const tableColumnsMap = {
  scheduled: {enabled: true, order: 1, permission: undefined, size: TableColumnSizeType.large},
  resource: {enabled: true, order: 2, permission: undefined, size: TableColumnSizeType.small},
  vehiclePlateNumber: {enabled: true, order: 3, permission: undefined, size: TableColumnSizeType.small},
  assistants: {enabled: true, order: 4, permission: undefined, size: TableColumnSizeType.large},
  deliveries: {enabled: true, order: 5, permission: undefined, size: TableColumnSizeType.small},
  accounts: {enabled: true, order: 6, permission: undefined, size: TableColumnSizeType.small},
  totals: {enabled: true, order: 7, permission: undefined, size: TableColumnSizeType.small},
  capacityRisks: {enabled: true, order: 8, permission: undefined, size: TableColumnSizeType.small},
  cost: {enabled: true, order: 9, permission: undefined, size: TableColumnSizeType.small},
  distance: {enabled: true, order: 10, permission: undefined, size: TableColumnSizeType.small},
  alerts: {enabled: true, order: 11, permission: undefined, size: TableColumnSizeType.small},
  progress: {enabled: true, order: 12, permission: undefined, size: TableColumnSizeType.medium},
  totalTime: {enabled: true, order: 13, permission: undefined, size: TableColumnSizeType.small},
  serviceAreas: {enabled: true, order: 14, permission: undefined, size: TableColumnSizeType.small},
  agentOperationalUnits: {enabled: true, order: 15, permission: undefined, size: TableColumnSizeType.small, hide: false},
}


angular
  .module('bringoz.admin.lean-planning')
  .constant('' +
    'leanPlanningConstants', {
    routeStatuses: routeStatuses,
    routeGroupKeys: routeGroupKeys,
    days: days,
    allRoutesActions: allRoutesActions,
    routeActionsByStatus: routeActionsByStatus,
    tableColumnsMap: tableColumnsMap
  });
